import React from "react";
import SMSHeader from "./SMSHeader";
import { IconButton, Tooltip } from "@material-ui/core";
import ClearIcon from "@material-ui/icons/Clear";

const SMSInbox = (props) => {
    return (
        <>
            <div className="popup_background">
                <div className="popup">
                    <div className="popup_close">
                        <Tooltip title="Close Button">
                            <IconButton onClick={props.handleClosePopup}>
                                <ClearIcon style={{ color: "black" }} />
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div className="popup_content">
                        {props.sms.length < 1 && "Your inbox is empty."}
                        {props.sms.map((sms) => {
                            return (
                                <>
                                    <SMSHeader {...sms} popup={true} />
                                    <hr />
                                </>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
};

export default SMSInbox;
